import { render, staticRenderFns } from "./DocumentBarcodeRecognition.vue?vue&type=template&id=5b894f0e&scoped=true&"
import script from "./DocumentBarcodeRecognition.vue?vue&type=script&lang=js&"
export * from "./DocumentBarcodeRecognition.vue?vue&type=script&lang=js&"
import style0 from "./DocumentBarcodeRecognition.vue?vue&type=style&index=0&id=5b894f0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b894f0e",
  null
  
)

export default component.exports